import { useEffect, useRef } from 'react';

interface SchemaOrgProps {
  schema: Record<string, unknown>;
}

export default function SchemaOrg({ schema }: SchemaOrgProps) {
  const ref = useRef<HTMLScriptElement | null>(null);

  useEffect(() => {
    const existingScript = document.querySelector('script[data-schema-dynamic]');
    if (existingScript) {
      existingScript.remove();
    }

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-schema-dynamic', 'true');
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
    ref.current = script;

    return () => {
      if (ref.current && ref.current.parentNode) {
        ref.current.parentNode.removeChild(ref.current);
      }
    };
  }, [schema]);

  return null;
}